<template>
  <div class="main-content">
    <div class="page-heading">{{ title }}</div>
    <OptionList v-model="selected" :items="items" :perRow="perRow" />
    <template v-for="(image, index) in images">
      <img class="w-100 mb-3" :src="image.url" @click="$refs[`lightbox-${index}`][0].show([image.url])" />
      <ImageLightBox :ref="`lightbox-${index}`" />
    </template>
  </div>
</template>

<script>
import ImageLightBox from '@/components/Page/Chatroom/ImageLightBox.vue'
import OptionList from '@/components/web/proj/tongxin/common/OptionList.vue'

export default {
  name: 'SelectionStep',
  components: { ImageLightBox, OptionList },
  props: {
    title: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    images: { type: Array, default: () => [] },
    value: { type: [String, Number], default: null },
    perRow: { type: Number, default: 4 }
  },
  data() {
    return { selected: this.value }
  },
  watch: {
    value(v) { this.selected = v },
    selected(v) { this.$emit('input', v) }
  }
}
</script>

<style scoped>
.main-content { padding: 0; }
</style>
